import ImageGallery from 'react-image-gallery';

import classes from './ImagesComponent.module.css';

import leftNav from '../../assets/img/leftNav.svg';
import rightNav from '../../assets/img/rightNav.svg';
const ImagesComponent = ({ images, width, height }) => {
  const preText = 'https://d1muf25xaso8hp.cloudfront.net/https%3A%2F%2F';
  const images1 = [];

  images = [...new Set(images)];
  images &&
    images.map((image) =>
      images1.push({
        original: preText + encodeURI(image).split('//')[1],
      }),
    );

  return (
    <div>
      {images1 && images1.length > 0 && (
        <div
          className={classes['shortlist__images']}
          style={{ width: { width }, height: { height } }}
        >
          {/* showFullscreenButton={true} */}
          <ImageGallery
            items={images1}
            showPlayButton={false}
            showFullscreenButton={false}
            originalHeight="100px"
            originalWidth={'100px'}
            renderLeftNav={(onClick, disabled) => {
              return (
                <button
                  className={classes['image-gallery-custom-left-nav']}
                  disabled={disabled}
                  onClick={onClick}
                >
                  <span>
                    <img src={leftNav} />
                  </span>
                </button>
              );
            }}
            renderRightNav={(onClick, disabled) => {
              return (
                <button
                  className={classes['image-gallery-custom-right-nav']}
                  disabled={disabled}
                  onClick={onClick}
                >
                  <span>
                    <img src={rightNav} />
                  </span>
                </button>
              );
            }}
            height="110px"
          />
        </div>
      )}
    </div>
  );

  // const [imageIndex, setImageIndex] = useState(0);

  // const rightHandler = () => {
  //     setImageIndex(imageIndex === images.length - 1 ? 0 : imageIndex + 1)
  // }

  // const leftHandler = () => {
  //     setImageIndex(imageIndex === 0 ? images.length - 1 : imageIndex - 1)
  // }
  // return (
  //     <div id={classes.imgs}>

  //         {images.map((item, idx) => {
  //             return (
  //                 <div className={imageIndex === idx ? classes['slide active'] : classes.slide} key={idx}>
  //                     {imageIndex === idx && <img src={item} />}
  //                 </div>)
  //         })}

  //         {/* <img src={images[imageIndex] } alt='alt'/> */}
  //         <div className={classes.left} onClick={leftHandler}> {"<"}</div>
  //         <div className={classes.right} onClick={rightHandler}> {">"}</div>

  //     </div>
  // )
};

export default ImagesComponent;
